import QuoteRebillModalWrapper from './QuoteRebillModalWrapper';
import RebillBody from './RebillBody';

const Rebill = ({
  onBackClick,
  onConsolidateServiceClick,
  onCheckout,
  location,
}: {
  onBackClick?: () => void;
  onConsolidateServiceClick?: () => void;
  onCheckout?: () => void;
  location?: {
    address1: string;
    address2?: string | null;
    city: string;
    state: string;
    zip_code: string;
  };
}) => {
  return (
    <QuoteRebillModalWrapper
      type="rebill"
      onBackClick={onBackClick}
      onConsolidateServiceClick={onConsolidateServiceClick}
      onCheckout={onCheckout}
    >
      <RebillBody location={location} />
    </QuoteRebillModalWrapper>
  );
};

export default Rebill;
